import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TouchpointEdit from './touchpoint-edit';
import Pagination from 'react-js-pagination';

export class TouchpointList extends Component {

  componentDidMount() {
    const { siteId, fetchFormList, loadFormDetails, permissionProps } = this.props;
    const { fetchTouchpointPermissions } = permissionProps || {};
    if(siteId) {
      fetchFormList(siteId)
        .then((value) => {
          const formIds = value.results.map(formSummary => formSummary.formId);
          loadFormDetails(siteId, formIds);
        });
      fetchTouchpointPermissions(siteId);
    }
  }

  componentWillUpdate(nextProps, nextState) {
    const { siteId, touchpointIds, fetchFormList, loadFormDetails, permissionProps } = nextProps;
    const { fetchTouchpointPermissions } = permissionProps || {};

    if(siteId) {
      fetchFormList(siteId, touchpointIds)
        .then((value) => {
          const formIds = value.results.map(formSummary => formSummary.formId);
          loadFormDetails(siteId, formIds);
        });
      fetchTouchpointPermissions(siteId);
    }
  }

  onOpenEdit(formId) {
    const { siteId, showFormDetails, fetchSettings } = this.props;
    showFormDetails(siteId, formId, true);
    fetchSettings(siteId, formId);
  }

  render() {
    const { siteId, siteName, forms, allForms, formsEditData, resultsPerPage, settings, settingsResponses, settingsSubmission, changePageNumber, showFormDetails, updateAlias, programData, programListActions, permissionProps } = this.props;

    var formList = [];
    var currentPage = 1;
    var totalItemsCount = 0;
    if(forms) {
      formList = forms.results;
      currentPage = forms.currentPage;
      totalItemsCount = forms.totalResults;
    }

    return (
      <div>
        <h3>{siteName}</h3>
        { !formList || formList.length === 0 ? <span>There are no Forms to display</span> : null }
        { formList && formList.map(formSummary => {
          const editData = formsEditData && formsEditData.get(formSummary.formId);
          const formData = allForms && allForms.get(formSummary.formId);
          const form = formData ? formData.data : {};
          const show = editData && editData.get('show');
          const programsState = programData && programData.getIn([siteId, formSummary.formId]);
          const { itemsPerPage : programsPerPage, sortBy: sortProgramsBy, sortAsc : sortProgramsAsc, programListState } = programsState || {};
          const { isFetching : programsLoading, err : programErr, programList } = programListState || { isFetching : false};
          const programListProps = {
            isFetching: programsLoading,
            err: programErr,
            programs: programList,
            sortBy: sortProgramsBy,
            sortAsc: sortProgramsAsc,
            resultsPerPage: programsPerPage,
            ...programListActions
          }

          const settingsState = settings && settings.getIn([siteId, formSummary.formId]);
          const { isFetching : settingsFetching, err : settingsErr, data } = settingsState || { isFetching : false };
          const response = settingsResponses && settingsResponses.getIn([siteId, formSummary.formId]);
          const settingsSubmissionState = settingsSubmission && settingsSubmission.get(siteId);

          const aliasProps = {
            updateAlias,
            isFetching : settingsFetching,
            err : settingsErr,
            response,
            defaultValue : data && data.alias,
            isSubmitting : settingsSubmissionState && settingsSubmissionState.isSubmitting
          };

          return (
            <TouchpointEdit
              key={formSummary.formId}
              name={formSummary.formName}
              id={formSummary.formId}
              isDisabled={formSummary.isDisabled}
              {...form}
              siteId={siteId}
              show={show}
              onOpen={e => this.onOpenEdit(formSummary.formId)}
              onClose={e => showFormDetails(siteId, formSummary.formId, false)}
              aliasProps={aliasProps}
              programListProps={programListProps}
              permissionProps={permissionProps}/>
          );
        })}
        {resultsPerPage < totalItemsCount ?
          <div className="pagination-display">
            <Pagination
              activePage={currentPage}
              itemsCountPerPage={resultsPerPage}
              totalItemsCount={totalItemsCount}
              pageRangeDisplayed={10}
              firstPageText={"First"}
              prevPageText={"Previous"}
              nextPageText={"Next"}
              lastPageText={"Last"}
              onChange={page => changePageNumber(siteId, page)}
            />
          </div>
          : null}
      </div>
    );
  }
}

TouchpointList.propTypes = {
  siteId: PropTypes.string,
  siteName: PropTypes.string,
  touchpointIds: PropTypes.array,
  forms: PropTypes.object,
  allForms: PropTypes.object,
  formsEditData : PropTypes.object,
  resultsPerPage: PropTypes.number,
  changePageNumber: PropTypes.func,
  showFormDetails: PropTypes.func,
  programData: PropTypes.object,
  programListActions: PropTypes.object,
  permissionProps: PropTypes.object,
};

export default TouchpointList;
